export type PaginationMeta = {
  currentPage?: number;
  totalPages?: number;
  hasNext?: boolean;
  hasPrevious?: boolean;
  total?: number;
  totalCount?: number;
  count?: number;
  limit?: number;
  itemsPerPage?: number;
};

export const getBufferedRequestLimit = (pageSize: number) =>
  Math.max(pageSize, 1);

export const getBufferedRequestPage = (page: number) =>
  Math.max(page, 1);

export const getBufferedPageOffset = (_page: number, _pageSize: number) => 0;

export const getTotalItemsFromMeta = (
  meta: PaginationMeta | undefined,
  requestLimit: number,
  currentItemsCount: number,
) => {
  if (!meta) {
    return currentItemsCount;
  }

  const directTotal = meta.totalCount ?? meta.total ?? meta.count;
  if (typeof directTotal === "number" && directTotal >= 0) {
    return directTotal;
  }

  if (typeof meta.totalPages === "number" && meta.totalPages > 0) {
    const safeCurrentPage = meta.currentPage ?? 1;
    const isLastPage = safeCurrentPage >= meta.totalPages;

    if (isLastPage) {
      return (meta.totalPages - 1) * requestLimit + currentItemsCount;
    }

    return meta.totalPages * requestLimit;
  }

  return currentItemsCount;
};

export const getUiTotalPages = (
  meta: PaginationMeta | undefined,
  pageSize: number,
  requestLimit: number,
  currentItemsCount: number,
) => {
  const totalItems = getTotalItemsFromMeta(meta, requestLimit, currentItemsCount);
  return Math.max(1, Math.ceil(totalItems / pageSize));
};
